// extracted by mini-css-extract-plugin
export default {"map":"styles_map__d9I4l","sidePanel":"styles_sidePanel__L-CID","back":"styles_back__KG6NB","icon":"styles_icon__fUOTC","courtInfo":"styles_courtInfo__4Eefu"};